import _ from 'lodash'
import { ReactNode } from 'react'

import { Dialog, DialogContent, DialogTitle, Stack } from '@mui/material'

import { DMPConnectVitaleCardForm, DMPConnectVitaleCardFormProps } from './DMPConnectVitaleCardForm'

export type DMPConnectVitaleCardDialogProps = {
  hideGetIns?: boolean
  onClose?: () => void
  onSelectPatient?: DMPConnectVitaleCardFormProps['onSelectPatient']
  open: boolean
  title: ReactNode
}

export function DMPConnectVitaleCardDialog(props: DMPConnectVitaleCardDialogProps) {
  const { hideGetIns, open, onClose, onSelectPatient, title } = props

  return (
    <Dialog
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          minWidth: '600px',
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <DMPConnectVitaleCardForm hideGetIns={hideGetIns} onSelectPatient={onSelectPatient} />
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
